import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import axios from "axios";
import moment from "moment-timezone";
import VCalendar from 'v-calendar';

Vue.config.productionTip = false;
axios.interceptors.response.use(
    response => {
        return response;
    },
    function(error) {
        if (typeof error.response === "undefined") {
            //window.location = '/error/connection-lost'
            console.log("undefined");
        }
        if (error && error.response.status === 401) {
            window.location = "/app/login";
        }
        if (error && error.response.status === 403) {
            window.location = "/app/login";
        }
        return Promise.reject(error.response);
    }
);

function getCookie(name) {
    var r = document.cookie.match("\\b" + name + "=([^;]*)\\b");
    return r ? r[1] : undefined;
}

let xsrf_token_meta = getCookie("_xsrf");
axios.defaults.headers.common = {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json"
};
axios.defaults.withCredentials = true;
if (xsrf_token_meta) {
    axios.defaults.headers.common["X-Xsrftoken"] = xsrf_token_meta;
}
//store.dispatch("fetchTranslations", "ET_ee");
Vue.prototype.t = Vue.filter("t", key => {
    if (store.state.translations && store.state.translations[key]) {
        return store.state.translations[key];
    }
    return key;
});
Vue.prototype.tz = Vue.filter("tz", date => {
    let newDate = moment
        .utc(date, "YYYY-MM-DD, HH:mm:ss")
        .tz(window.app.pageData.timezone)
        .format("YYYY-MM-DD, HH:mm:ss");
    if (!newDate) return date;
    return newDate;
});

Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});

let vueapp = new Vue({
    vuetify,
    router,
    store,
    template: "<App/>",
    components: { App }
}).$mount("#app");
export default vueapp;
